import { MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

import { useAppContext } from "../../context/AppContext";

interface PatientExportsMenuDeleteProps {
  exportId: string;
  date: string;
  onClose: () => void;
}

export const PatientExportsMenuDelete: React.FC<PatientExportsMenuDeleteProps> = ({
  exportId,
  date,
  onClose,
}) => {
  const { t } = useTranslation();
  const { setDeleteExportDialog } = useAppContext();
  
  const handleDelete = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClose();
    setDeleteExportDialog({ open: true, id: exportId, date });
  };

  return (
    <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
      <CloseIcon fontSize="small" sx={{ mr: 1.5 }} />
      {t("common.delete")}
    </MenuItem>
  );
};

export default PatientExportsMenuDelete;